import {
  Article,
  ArticleAction,
  ArticleImage,
  ArticleList,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { Badge } from "@babackapp/customer-ui/components/badge";
import { Checkbox } from "@babackapp/customer-ui/components/checkbox";
import type { OrderLineItem } from "../types";
import { formatPrice } from "../utils/format-price";

type ArticleRowProps = {
  item: OrderLineItem;
  checked: boolean;
  onToggle: () => void;
  disabled?: boolean;
  badge?: string;
  currency?: string;
};

export function ArticleRow({
  item,
  checked,
  onToggle,
  disabled = false,
  badge,
  currency = "EUR",
}: ArticleRowProps) {
  const options = [item.variant?.option1, item.variant?.option2, item.variant?.option3]
    .filter(Boolean)
    .filter((o) => o !== "Default Title")
    .join(" • ");

  const price = typeof item.price === "number" ? formatPrice(item.price * 100, currency) : null;
  const subtitle = [options, price].filter(Boolean).join(" • ") || null;

  return (
    <Article disabled={disabled} onClick={disabled ? undefined : onToggle}>
      {item.image && <ArticleImage src={item.image} alt={item.title} />}
      <ArticleTitle>{item.title}</ArticleTitle>
      {subtitle && <ArticleSubtitle>{subtitle}</ArticleSubtitle>}
      <ArticleAction autoHide={false}>
        {badge ? (
          <Badge>{badge}</Badge>
        ) : (
          <Checkbox
            checked={checked}
            onCheckedChange={onToggle}
            disabled={disabled}
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </ArticleAction>
    </Article>
  );
}

export { ArticleList };
